import products from "db/products.json";
import productsConfigurations from "db/products_configurations.json";
import linesProductsConfigurations from "db/line_configuration_options.json";

export const findProduct = (circle) => {
  // check solo su config passate

  return productsConfigurations.filter((pC) => {
    if (circle.type === "hydraulic") {
      return (
        (!!circle?.setting?.body_size
          ? pC.body_size === circle?.setting?.body_size?.value
          : true) &&
        (!!circle?.setting?.thread
          ? pC.thread === circle?.setting?.thread?.value
          : true) &&
        (!!circle?.setting?.port
          ? pC.port === circle?.setting?.port?.value
          : true)
      );
    } else {
      // non controllo più le config delle ec
      // return (
      //   pC.body_size === circle?.setting?.body_size?.value &&
      //   pC.poles === circle?.setting?.poles?.value
      // );
      // ritorno solo una qualsiasi EC
      return pC.code.includes("EC");
    }
  });
};

const getSimilarPlacca = (
  placca,
  bodySizeVariation,
  excludedConfigurations
) => {
  return placca
    .filter((line) => !!line)
    .map((line) => {
      if (line.type === "hydraulic") {
        // HYDRAULIC
        if (bodySizeVariation) {
          let bodySize = line.setting.body_size.value;
          const bodySizeValues = linesProductsConfigurations.hydraulic.find(
            (config) => config.id === "body_size"
          ).options;
          const configIndex = bodySizeValues.findIndex(
            (config) => config.value === bodySize
          );
          if (configIndex !== bodySizeValues.length - bodySizeVariation) {
            const body_size = {
              ...bodySizeValues[configIndex + bodySizeVariation],
            };
            const litre = body_size.reference.data;
            delete body_size.reference;
            line = {
              ...line,
              setting: {
                ...line.setting,
                body_size,
                litre,
              },
            };
          }
        }
        if (excludedConfigurations) {
          let setting = { ...line.setting };
          setting = Object.fromEntries(
            Object.entries(setting).filter(
              ([key, value]) =>
                !excludedConfigurations.some(
                  (config) => config.type === "hydraulic" && config.key === key
                )
            )
          );
          line = {
            ...line,
            setting,
          };
        }
        return line;
      } else {
        // ELECTRIC
        if (excludedConfigurations) {
          let setting = { ...line.setting };
          setting = Object.fromEntries(
            Object.entries(setting).filter(
              ([key, value]) =>
                !excludedConfigurations.some(
                  (config) => config.type === "electric" && config.key === key
                )
            )
          );
          line = {
            ...line,
            setting,
          };
        }
        return line;
      }
    });
};

export const findMatching = (placca) => {
  const formattedPlacca = formatPlacca(placca);
  const found = deepSearch(products, formattedPlacca);

  // similarPlaccaExcludingThread
  const similarPlaccaExcludingThread = getSimilarPlacca(placca, null, [
    { type: "hydraulic", key: "thread" },
  ]);
  const formattedSimilarPlaccaExcludingThread = formatPlacca(
    similarPlaccaExcludingThread
  );

  const foundSimilarPlaccaExcludingThread = deepSearch(
    products,
    formattedSimilarPlaccaExcludingThread
  );

  // similarPlaccaExcludingPort
  const similarPlaccaExcludingPort = getSimilarPlacca(placca, null, [
    { type: "hydraulic", key: "port" },
  ]);

  const formattedSimilarPlaccaExcludingPort = formatPlacca(
    similarPlaccaExcludingPort
  );

  const foundSimilarPlaccaExcludingPort = deepSearch(
    products,
    formattedSimilarPlaccaExcludingPort
  );

  // similarPlaccaExcludingThreadAndPort
  const similarPlaccaExcludingThreadAndPort = getSimilarPlacca(placca, null, [
    { type: "hydraulic", key: "thread" },
    { type: "hydraulic", key: "port" },
  ]);

  const formattedSimilarPlaccaExcludingThreadAndPort = formatPlacca(
    similarPlaccaExcludingThreadAndPort
  );

  const foundSimilarPlaccaExcludingThreadAndPort = deepSearch(
    products,
    formattedSimilarPlaccaExcludingThreadAndPort
  );

  // similarPlaccaOneBodySizeVariation
  const similarPlaccaOneBodySizeVariation = getSimilarPlacca(placca, 1);

  const formattedSimilarPlaccaOneBodySizeVariation = formatPlacca(
    similarPlaccaOneBodySizeVariation
  );

  const foundSimilarPlaccaOneBodySizeVariation = deepSearch(
    products,
    formattedSimilarPlaccaOneBodySizeVariation
  );

  // similarPlaccaOneBodySizeVariationExcludingThread
  const similarPlaccaOneBodySizeVariationExcludingThread = getSimilarPlacca(
    placca,
    1,
    [{ type: "hydraulic", key: "thread" }]
  );
  const formattedSimilarPlaccaOneBodySizeVariationExcludingThread =
    formatPlacca(similarPlaccaOneBodySizeVariationExcludingThread);
  const foundSimilarPlaccaOneBodySizeVariationExcludingThread = deepSearch(
    products,
    formattedSimilarPlaccaOneBodySizeVariationExcludingThread
  );

  // similarPlaccaOneBodySizeVariationExcludingPort
  const similarPlaccaOneBodySizeVariationExcludingPort = getSimilarPlacca(
    placca,
    1,
    [{ type: "hydraulic", key: "port" }]
  );
  const formattedSimilarPlaccaOneBodySizeVariationExcludingPort = formatPlacca(
    similarPlaccaOneBodySizeVariationExcludingPort
  );
  const foundSimilarPlaccaOneBodySizeVariationExcludingPort = deepSearch(
    products,
    formattedSimilarPlaccaOneBodySizeVariationExcludingPort
  );

  // similarPlaccaOneBodySizeVariationExcludingThreadAndPort
  const similarPlaccaOneBodySizeVariationExcludingThreadAndPort =
    getSimilarPlacca(placca, 1, [
      { type: "hydraulic", key: "thread" },
      { type: "hydraulic", key: "port" },
    ]);
  const formattedSimilarPlaccaOneBodySizeVariationExcludingThreadAndPort =
    formatPlacca(similarPlaccaOneBodySizeVariationExcludingThreadAndPort);
  const foundSimilarPlaccaOneBodySizeVariationExcludingThreadAndPort =
    deepSearch(
      products,
      formattedSimilarPlaccaOneBodySizeVariationExcludingThreadAndPort
    );

  // similarPlaccaExcludingEc
  const similarPlaccaExcludingEc = getSimilarPlacca(placca, null, [
    { type: "electric", key: "body_size" },
    { type: "electric", key: "poles" },
  ]);
  const formattedSimilarPlaccaExcludingEc = formatPlacca(
    similarPlaccaExcludingEc
  );
  const foundSimilarPlaccaExcludingEc = deepSearch(
    products,
    formattedSimilarPlaccaExcludingEc
  );

  // similarPlaccaExcludingEc
  const similarPlaccaExcludingEcOneBodySizeVariation = getSimilarPlacca(
    placca,
    1,
    [
      { type: "electric", key: "body_size" },
      { type: "electric", key: "poles" },
    ]
  );
  const formattedSimilarPlaccaExcludingEcOneBodySizeVariation = formatPlacca(
    similarPlaccaExcludingEcOneBodySizeVariation
  );
  const foundSimilarPlaccaOneBodySizeVariationExcludingEc = deepSearch(
    products,
    formattedSimilarPlaccaExcludingEcOneBodySizeVariation
  );

  let results = {
    found,
    foundSimilarPlaccaExcludingThread,
    foundSimilarPlaccaExcludingPort,
    foundSimilarPlaccaExcludingThreadAndPort,
    foundSimilarPlaccaOneBodySizeVariation,
    foundSimilarPlaccaOneBodySizeVariationExcludingThread,
    foundSimilarPlaccaOneBodySizeVariationExcludingPort,
    foundSimilarPlaccaOneBodySizeVariationExcludingThreadAndPort,
    foundSimilarPlaccaExcludingEc,
    foundSimilarPlaccaOneBodySizeVariationExcludingEc,
  };

  results = getMatchingProducts(
    results,
    placca.filter((line) => !!line).length
  );

  return results;
};

export const formatPlacca = (placca) => {
  return placca
    .filter((line) => !!line)
    .reduce((acc, curr) => {
      const matchingProducts = findProduct(curr);

      if (!matchingProducts) {
        return acc;
      }

      const formattedProducts = matchingProducts.reduce((acc, curr) => {
        return {
          ...acc,
          [curr.code]: curr.code.includes("EC") ? 1 : (acc[curr.code] || 0) + 1,
        };
      }, {});
      return [...acc, formattedProducts];
    }, []);
};

const dimensions_refs = {
  9: "3/8",
  13: "1/2",
  15: "5/8",
  17: "3/4",
  21: "1",
};

const deepSearch = (arrayToSearch, arrayObjValue) => {
  // 1 parto dall'elenco dei prodotti "arrayToSearch"
  // e dall'elenco delle configurazioni "arrayObjValue"

  return arrayObjValue.reduce(
    (acc, objValue) => {
      // 2 per ogni oggetto configurazione filtro i prodotti che hanno quella configurazione
      // "acc" in partenza è l'elenco dei prodotti tra cui cercare
      // "objValue" è un oggetto configurazione di questo tipo {FAP13 1/2 BSP: 1, FAQ13 1/2 BSP: 1, FAQ13E 1/2 BSP: 1}
      return acc
        .filter((obj) => {
          // 3 controllo gli oggetti da filtrare "obj" e verifico che abbiano la configurazione che sto cercando e che la abbiano ancora disponibile
          // trasformo {FAP13 1/2 BSP: 1, FAQ13 1/2 BSP: 1, FAQ13E 1/2 BSP: 1} in ["FAP13 1/2 BSP", "FAQ13 1/2 BSP", "FAQ13E 1/2 BSP"]
          // per facilitare la ricerca potendo mappare / filtrare l'array
          const values = Object.keys(objValue);
          // 4 mappo l'elenco delle configurazioni e lascio solo i prodotti che hanno quella configurazione disponibile
          // è giusto >= 1 perchè vengono ridotti solo nel ciclo dopo e c'è un ulteriore filter alla fine
          return values.some((value) => !!obj[value] && obj[value] >= 1);
        })
        .map((obj) => {
          // 5 dopo aver filtrato quelli non corrispondono alle configurazioni che stiamo cercando
          // rimappo l'array e ad ogni prodotto rimasto diminuisco di 1 le configurazioni che sto cercando

          // trasformo {FAP13 1/2 BSP: 1, FAQ13 1/2 BSP: 1, FAQ13E 1/2 BSP: 1} in ["FAP13 1/2 BSP", "FAQ13 1/2 BSP", "FAQ13E 1/2 BSP"]
          // per facilitare la ricerca potendo mappare / filtrare l'array
          let values = Object.keys(objValue);

          // tolgo da values quelle che non sono presenti nell'obj
          values = values.filter((value) => !!obj[value]);

          // trasformo il prodotto "obj" da oggetto a array [key, value] per facilitare la mappatura
          const objArr = Object.entries(obj);

          // parto dal nuovo array per ritrasformarlo in un oggetto e ad ogni ciclo [key, value] diminuisco di 1 la disponibilità
          return objArr.reduce((accObjArr, [key, value]) => {
            // cerco il prodotto corrispondente alla configurazione
            const product = productsConfigurations.find((p) => p.code === key);

            // se lo trovo procedo altrimenti non server diminuire la disponibilità perchè è una key non di configurazione es. "code", "name"
            if (product) {
              // controllo se la chiave che sto guardando è una di quelle che sto cercando
              const isSearchedKey = !!values.find((val) => val === key);

              // diminuisco di 1 la configurazione che sto controllando
              // e unisco l'oggetto delle configurazioni con la stessa dimensione
              let newObj = {
                ...accObjArr,
                [key]: isSearchedKey ? value - 1 : value,
              };

              return newObj;
            } else {
              return {
                ...accObjArr,
                [key]: accObjArr[key] || value,
              };
            }
          }, {});
        })
        .filter((obj) => {
          // lascio solo quelli che hanno tutte le chiavi >= 0
          const arrValues = Object.values(obj);
          return arrValues.every((val) => {
            if (typeof val === "number") {
              return val >= 0;
            }
            return true;
          });
        });
    },
    arrayToSearch.filter((product) => {
      // return true

      // check relativo solo alle empty
      const isEmpty = product.name.includes("EMPTY");
      if (!isEmpty) {
        return true;
      }

      // lascio solo le config che riguardano il prodotto
      const filteredArrayConfigs = arrayObjValue
        .map((config) => {
          return Object.keys(config).filter((key) => !!product[key]);
        })
        .filter((config) => !!config.length);

      // se la dimensione è diversa vuol dire che il prodotto non ha qualche linea
      // che è presente nella configurazione e quindi posso già toglierlo
      if (arrayObjValue.length < filteredArrayConfigs.length) {
        return false;
      }

      // trasformo la configurazione in dimensioni e
      const configDimensions = configToDimensions(filteredArrayConfigs);

      // confronto con le dimensioni disponibili nel prodotto
      // a quelle inserite nella placca
      const dimensionsDifference = Object.entries(product.dimensions).map(
        ([dimension, value]) => {
          return value - (configDimensions[dimension] || 0);
        }
      );

      return dimensionsDifference.every((dimension) => dimension >= 0);
    })
  );
};

const configToDimensions = (arrConfigs) => {
  // trasformo l'array di possibili configurazioni in dimensioni
  return arrConfigs.reduce((acc, arrConfig) => {
    // cerco la dimensione
    const config = productsConfigurations.find(
      (pC) => pC.code === arrConfig[0]
    );
    const { body_size } = config;
    const dimension = dimensions_refs[body_size] || body_size;
    return {
      ...acc,
      [dimension]: (acc[dimension] || 0) + 1,
    };
  }, {});
};

const groupFixMobile = (arr) => {
  return arr.reduce((acc, curr) => {
    if (curr.name.toLowerCase().includes("complete")) {
      return {
        ...acc,
        complete: [...(acc.complete || []), curr],
      };
    }
    if (curr.name.toLowerCase().includes("empty")) {
      // const code = cleanDescription(curr.name, [
      //   "MULTI",
      //   "MOBILE",
      //   "FIX",
      //   "EMPTY",
      //   "COMPLETE",
      // ]);
      const code =
        curr.description ||
        curr.picture ||
        cleanDescription(curr.name, [
          "MULTI",
          "MOBILE",
          "FIX",
          "EMPTY",
          "COMPLETE",
        ]);
      const empty = acc.empty || [];
      let couple = empty.find((c) => c.code === code);
      if (couple) {
        couple.couple = [...couple.couple, curr];
      } else {
        empty.push({
          code,
          couple: [curr],
        });
      }
      return {
        ...acc,
        empty,
      };
    }
    if (
      curr.name.toLowerCase().includes("fix") ||
      curr.name.toLowerCase().includes("mobile")
    ) {
      // const code = cleanDescription(curr.name, [
      //   "MULTI",
      //   "MOBILE",
      //   "FIX",
      //   "EMPTY",
      //   "COMPLETE",
      // ]);
      const code =
        curr.description ||
        curr.picture ||
        cleanDescription(curr.name, [
          "MULTI",
          "MOBILE",
          "FIX",
          "EMPTY",
          "COMPLETE",
        ]);
      let couple = acc.couple || [];
      const singleCouple = couple.find((c) => c.code === code);
      if (singleCouple) {
        singleCouple.couple = [...singleCouple.couple, curr];
      } else {
        couple.push({
          code,
          couple: [curr],
        });
      }
      return {
        ...acc,
        couple,
      };
    }
    return null;
  }, {});
};

const cleanDescription = (string, arr) => {
  return string
    .split(" ")
    .filter((word) => !arr.find((text) => text === word))
    .join(" ");
};

export const getOptionsByConfig = (target, configs, type) => {
  const copy = { ...configs };
  delete copy[target];
  delete copy.litre;
  let options = Object.entries(copy)
    .filter(([key, value]) => !!value)
    .reduce((acc, [key, value]) => {
      if (
        (target === "body_size" && key === "litre") ||
        (target === "litre" && key === "body_size")
      ) {
        return acc;
      }
      return acc.filter((product) => product[key] === value?.value);
    }, productsConfigurations);
  options = options?.filter((option) => !!option);
  options = options?.map((product) => {
    if (target === "litre") {
      const referenceConfig = linesProductsConfigurations.hydraulic
        .find((line) => line.id === "body_size")
        .options.find((option) => option?.value === product["body_size"])
        ?.reference?.data;
      const litreValue = linesProductsConfigurations.hydraulic
        .find((line) => line.id === "litre")
        ?.options?.find((option) => option?.value === referenceConfig?.value);
      return litreValue?.value;
    }
    return product[target];
  });
  options = options?.filter((option) => !!option);
  options = [...new Set(options)];
  options = options?.map((option) => {
    const configurationOptions = linesProductsConfigurations[type]
      .find((cO) => cO.id === target)
      .options?.find((op) => op.value === option);
    return configurationOptions;
  });
  options = options?.filter((option) => !!option);
  return options;
};

const getMatchingProducts = (products, totalLines) => {
  // Complete perfect
  let completePerfect = getMatchingProduct(
    products.found,
    totalLines,
    "complete"
  );

  // Complete different thread
  let completeDifferentThread = getMatchingProduct(
    products.foundSimilarPlaccaExcludingThread,
    totalLines,
    "complete"
  );

  // Complete different port
  let completeDifferentPort = getMatchingProduct(
    products.foundSimilarPlaccaExcludingPort,
    totalLines,
    "complete"
  );

  // Complete different thread or port
  let completeDifferentPortOrThread = getMatchingProduct(
    products.foundSimilarPlaccaExcludingThreadAndPort,
    totalLines,
    "complete"
  );

  // Empty perfect
  let emptyPerfect = getMatchingProduct(products.found, totalLines, "empty");

  // Empty up total_lines +1
  let emptyTotalLinesPlusOne = getMatchingProduct(
    products.found,
    totalLines + 1,
    "empty"
  );

  // Empty up total_lines +1 different ec
  let emptyTotalLinesPlusOneDifferentEc = getMatchingProduct(
    products.foundSimilarPlaccaExcludingEc,
    totalLines + 1,
    "empty"
  );

  // Empty up total_lines +2
  let emptyTotalLinesPlusTwo = getMatchingProduct(
    products.found,
    totalLines + 2,
    "empty"
  );

  // Empty up total_lines +2 different ec
  let emptyTotalLinesPlusTwoDifferentEc = getMatchingProduct(
    products.foundSimilarPlaccaExcludingEc,
    totalLines + 2,
    "empty"
  );

  // Empty up total_lines +N
  let emptyTotalLinesPlusN = getMatchingProduct(
    products.found,
    totalLines + 9,
    "empty",
    "allLines"
  );

  // Empty up total_lines +N different ec
  let emptyTotalLinesPlusNDifferentEc = getMatchingProduct(
    products.foundSimilarPlaccaExcludingEc,
    totalLines + 9,
    "empty",
    "allLines"
  );

  // Complete body_size +1
  let completeBodySizePlusOne = getMatchingProduct(
    products.foundSimilarPlaccaOneBodySizeVariation,
    totalLines,
    "complete"
  );

  // Complete body_size +1 different thread
  let completeBodySizePlusOneDifferentThread = getMatchingProduct(
    products.foundSimilarPlaccaOneBodySizeVariationExcludingThread,
    totalLines,
    "complete"
  );

  // Complete body_size +1 different port
  let completeBodySizePlusOneDifferentPort = getMatchingProduct(
    products.foundSimilarPlaccaOneBodySizeVariationExcludingPort,
    totalLines,
    "complete"
  );

  // Complete body_size +1 different thread or port
  let completeBodySizePlusOneDifferentPortOrThread = getMatchingProduct(
    products.foundSimilarPlaccaOneBodySizeVariationExcludingThreadAndPort,
    totalLines,
    "complete"
  );

  // Empty body_size +1
  let emptyBodySizePlusOne = getMatchingProduct(
    products.foundSimilarPlaccaOneBodySizeVariation,
    totalLines,
    "empty"
  );

  // Empty body_size +1 total_lines +1
  let emptyBodySizePlusOneTotalLinesPlusOne = getMatchingProduct(
    products.foundSimilarPlaccaOneBodySizeVariation,
    totalLines + 1,
    "empty"
  );

  // Empty body_size +1 total_lines +1 different ec
  let emptyBodySizePlusOneTotalLinesPlusOneDifferentEc = getMatchingProduct(
    products.foundSimilarPlaccaOneBodySizeVariationExcludingEc,
    totalLines + 1,
    "empty"
  );

  // Empty body_size +1 total_lines +2
  let emptyBodySizePlusOneTotalLinesPlusTwo = getMatchingProduct(
    products.foundSimilarPlaccaOneBodySizeVariation,
    totalLines + 2,
    "empty"
  );

  // Empty body_size +1 total_lines +2 different ec
  let emptyBodySizePlusOneTotalLinesPlusTwoDifferentEc = getMatchingProduct(
    products.foundSimilarPlaccaOneBodySizeVariationExcludingEc,
    totalLines + 2,
    "empty"
  );

  // Empty body_size +1 total_lines +N
  let emptyBodySizePlusOneTotalLinesPlusN = getMatchingProduct(
    products.foundSimilarPlaccaOneBodySizeVariation,
    totalLines + 9,
    "empty",
    "allLines"
  );

  // Empty body_size +1 total_lines +N different ec
  let emptyBodySizePlusOneTotalLinesPlusNDifferentEc = getMatchingProduct(
    products.foundSimilarPlaccaOneBodySizeVariationExcludingEc,
    totalLines + 9,
    "empty",
    "allLines"
  );

  let results = {
    completePerfect,
    completeDifferentThread,
    completeDifferentPort,
    completeDifferentPortOrThread,
    emptyPerfect,
    emptyTotalLinesPlusOne,
    emptyTotalLinesPlusOneDifferentEc,
    emptyTotalLinesPlusTwo,
    emptyTotalLinesPlusTwoDifferentEc,
    emptyTotalLinesPlusN,
    emptyTotalLinesPlusNDifferentEc,
    completeBodySizePlusOne,
    completeBodySizePlusOneDifferentThread,
    completeBodySizePlusOneDifferentPort,
    completeBodySizePlusOneDifferentPortOrThread,
    emptyBodySizePlusOne,
    emptyBodySizePlusOneTotalLinesPlusOne,
    emptyBodySizePlusOneTotalLinesPlusOneDifferentEc,
    emptyBodySizePlusOneTotalLinesPlusTwo,
    emptyBodySizePlusOneTotalLinesPlusTwoDifferentEc,
    emptyBodySizePlusOneTotalLinesPlusN,
    emptyBodySizePlusOneTotalLinesPlusNDifferentEc,
  };

  // FILTRO I DOPPIONI
  results = filterDuplicates(results);

  // RAGGRUPPO FIX E MOBILE
  results = groupResults(results);
  return results;
};

const getMatchingProduct = (products, totalLines, type, allLines) => {
  return products.filter((product) => {
    let matchLines;
    if (!!allLines) {
      matchLines = product.total_lines < totalLines;
    } else {
      matchLines = product.total_lines === totalLines;
    }
    const matchType = product.name.toLowerCase().includes(type);
    return matchLines && matchType;
  });
};

/*!
 * Find the differences between two objects and push to a new object
 * (c) 2019 Chris Ferdinandi & Jascha Brinkmann, MIT License, https://gomakethings.com & https://twitter.com/jaschaio
 * @param  {Object} obj1 The original object
 * @param  {Object} obj2 The object to compare against it
 * @return {Object}      An object of differences between the two
 */
export const getObjDifference = (obj1, obj2) => {
  // Make sure an object to compare is provided
  if (!obj2 || Object.prototype.toString.call(obj2) !== "[object Object]") {
    return obj1;
  }

  //
  // Variables
  //

  var diffs = {};
  var key;

  //
  // Methods
  //

  var arraysMatch = function (arr1, arr2) {
    // Check if the arrays are the same length
    if (arr1.length !== arr2.length) return false;

    // Check if all items exist and are in the same order
    for (var i = 0; i < arr1.length; i++) {
      if (arr1[i] !== arr2[i]) return false;
    }

    // Otherwise, return true
    return true;
  };

  /**
   * Compare two items and push non-matches to object
   * @param  {*}      item1 The first item
   * @param  {*}      item2 The second item
   * @param  {String} key   The key in our object
   */
  var compare = function (item1, item2, key) {
    // Get the object type
    var type1 = Object.prototype.toString.call(item1);
    var type2 = Object.prototype.toString.call(item2);

    // If type2 is undefined it has been removed
    if (type2 === "[object Undefined]") {
      diffs[key] = null;
      return;
    }

    // If items are different types
    if (type1 !== type2) {
      diffs[key] = item2;
      return;
    }

    // If an object, compare recursively
    if (type1 === "[object Object]") {
      var objDiff = getObjDifference(item1, item2);
      if (Object.keys(objDiff).length > 0) {
        diffs[key] = objDiff;
      }
      return;
    }

    // If an array, compare
    if (type1 === "[object Array]") {
      if (!arraysMatch(item1, item2)) {
        diffs[key] = item2;
      }
      return;
    }

    // Else if it's a function, convert to a string and compare
    // Otherwise, just compare
    if (type1 === "[object Function]") {
      if (item1.toString() !== item2.toString()) {
        diffs[key] = item2;
      }
    } else {
      if (item1 !== item2) {
        diffs[key] = item2;
      }
    }
  };

  //
  // Compare our objects
  //

  // Loop through the first object
  for (key in obj1) {
    if (obj1.hasOwnProperty(key)) {
      compare(obj1[key], obj2[key], key);
    }
  }

  // Loop through the second object and find missing items
  for (key in obj2) {
    if (obj2.hasOwnProperty(key)) {
      if (!obj1[key] && obj1[key] !== obj2[key]) {
        diffs[key] = obj2[key];
      }
    }
  }

  // Return the object of differences
  return diffs;
};

const filterDuplicates = (results) => {
  // return results
  let found = [];
  return Object.entries(results).reduce((acc, [key, value]) => {
    const filtered = value.filter(
      (val) => !found.some((prod) => prod.code === val.code)
    );
    found = [...found, ...value];
    return {
      ...acc,
      [key]: filtered,
    };
  }, {});
};

const groupResults = (results) => {
  return Object.entries(results).reduce((acc, [key, value]) => {
    return {
      ...acc,
      [key]: groupFixMobile(value),
    };
  }, {});
};

// OLD
/* if (isSearchedKey) {
  // trovo il body_size corrispondente
  const { body_size } = product;

  const refs = {
    "3/8": "9",
    "1/2": "13",
    "5/8": "15",
    "3/4": "17",
    1: "21",
  };
  const fixedBodySize = refs[body_size];

  const hydraulic_refs = body_size === "3/8" ? ["EC6", "EC7"] : body_size === "1/2" ? ["EC6-13", "EC7-13"] : []

  // solo se è empty          
  if (isEmpty) {
    // filtro le key del prodotto e lascio solo quelle della stessa dimensione
    sameSize = objArr
      ?.filter(([key2, value2]) => {
        // se è la stessa chiave che sto guardando non la lascio
        if (key2 === key) return false;
        // sfrutto il nome della chiave per cercare
        if (type === "electric") {
          if (!hasAlreadyBeenReduced) {
            hasAlreadyBeenReduced = true
            return (
              key2.includes(`FAP${fixedBodySize}`) ||
              // key2.includes(`EC ${body_size}`) // TODO: perchè c'era lo spazio?
              // key2.includes(`EC${body_size}`)
              // key2.includes(
              //   body_size === "9"
              //     ? "EC"
              //     : body_size === "13"
              //       ? new RegExp(/EC.*-13/gm)
              //       : null
              // )
              !!hydraulic_refs.some(ref => key2 === ref)
            );
          } else {
            return false
          }
        } else {
          // TODO: controllare che non rompa altro
          // return key2.includes(`FAP${body_size}`);
          return false;
        }
      })
      ?.reduce((accSameSize, [key2, value2]) => {
        // trasformo l'array di [key, value] che hanno la stessa dimensione della configurazione che sto cercando
        // in un oggetto in cui value è diminuita di uno
        // se la chiave è già presente nell'oggetto che sto riducendo "accObjArr" allora diminuisco di 1 dalla sua configurazione
        // altrimenti diminuisco di 1 dalla configurazione di partenza
        const fixedValue = accObjArr[key2] || value2;
        return {
          ...accSameSize,
          [key2]: fixedValue - 1,
        };
      }, {});
  }
} */
